import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  inject,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { OpenGetAppDirective } from '@shared/directives';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';

type DonationItem = {
  amount: number;
  currency: string;
  icon: string;
};

@Component({
  standalone: true,
  selector: 'cheelee-donation',
  templateUrl: './donation.component.html',
  styleUrl: './donation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    OpenGetAppDirective,
  ],
})
export class DonationComponent {
  @ViewChild('donationEl', { static: true }) readonly donationEl?: ElementRef<HTMLElement>;

  // @HostListener('wheel', ['$event'])
  // onScroll(evt: WheelEvent): void {
  //   evt.preventDefault();
  //
  //   if (this.donationEl) {
  //     this.donationEl.nativeElement.scrollLeft += Math.round(evt.deltaX !== -0 ? evt.deltaX : evt.deltaY);
  //   }
  // }

  @HostBinding('class')
  get classes(): Record<string, boolean> {
    return {

    };
  }

  protected readonly items: DonationItem[] = [
    { amount: 0.1, currency: 'LEE', icon: '🔥' },
    { amount: 0.5, currency: 'LEE', icon: '❤️' },
    { amount: 1, currency: 'LEE', icon: '✨' },
    { amount: 5, currency: 'LEE', icon: '🥰' },
    { amount: 10, currency: 'LEE', icon: '😍' },
  ];

  protected readonly analyticsEvents = AnalyticsEventsEnum;

  protected readonly control = new FormControl<number>(0);
}
